export default "src/content/themes/association-wordpress-theme/img/3cd6dd9808474f6ed7620d5d1686bd00.png";